<template>
    <div class="page_title"> <font-awesome-icon icon="parking" /> P샵 </div>
    
    <div class="item_list" v-if="goodsLists.length >0">
        <div class="item_box" v-for="(item, index) in goodsLists" :key="index">
            
            <div class="item_head">
                <h1>{{item.title}}</h1>
                <!--<p>{{item.description}}</p>-->
            </div>
            <div class="item_img">
                <div v-if="item.image" :style="{backgroundImage:`url(/storage/${item.image})`}">           
                    <!-- <img :src="`/storage/${item.image}`"> -->
                </div>
                <div v-else class="blank_img">
                    {{item.title}}
                </div>
            </div>
            <div class="item_footer" :class="{point_item:item.price>0}">
                <h1 v-if="item.price>0">{{addCom(item.price)}} 원</h1>
                <h1 v-else>{{addCom(Math.abs(item.point))}} P</h1>
                <button @click="goGoodsBuy(item.id)">구매하기</button>
            </div>
        </div>
    </div>
    <div v-else class="empty_list">
        등록된 상품이 없습니다.
    </div>
</template>
<script>
import { addCommas } from '@/utils/checkdata.js';
export default {
    name:'goodsList',
    data(){
        return{
            isLoading:true,
            goods:''
        }
    },
    mounted(){
        this.fetchGoods();
    },
    computed:{
        goodsLists:{
            get(){
                return this.$store.state.goods.goods;
            }
        },
    },
    methods:{
        goGoodsBuy(id)
        {
            this.$router.push('/main/goods/view/'+id);
        },
        addCom(val)
        {
            return addCommas(val);
        },
        async fetchGoods() {
            const formData = {
                data:1
            }
            try {
                const response = await this.$store.dispatch("goods/fetchGoods", formData)
                console.log('p샵 상품',response);
                this.goods = response.data;
                //console.log("안나오는듯",this.postlists.data.length);
            }catch(error){
                console.log(error.response);
            }
            this.isLoading = false;
        },

    }
}
</script>
<style lang="scss" scoped>
.item_list
{
    font-family:'Helvetica Neue',Arial,'맑은고딕',sans-serif;
    display:flex;
    flex-wrap:wrap;
    .item_box:hover{
        box-shadow: 0 10px 15px -3px rgba(0,0,0,.5),0 4px 6px -2px rgba(0,0,0,.5);
    }
    .item_box{
        box-shadow: 0 10px 15px -3px rgba(0,0,0,.1),0 4px 6px -2px rgba(0,0,0,.05);
        width: 30%;
        overflow: hidden;
        margin: 0.5rem;
        border-radius: .5rem;
        background-color: #fff;
        .item_head{
            padding-left: 1rem;
            padding-right: 1rem;
            padding-top: .5rem;
            padding-bottom: .5rem;
            h1{
                font-size: .7rem;
                color: #1a202c;
                font-weight: 700;
                margin: 0;
            }
            p{
                color: #718096;
                font-size: .8rem;
                margin-top: .25rem;
            }
        }
        .item_img{
            height: 12rem;
            overflow:hidden;
            div{
                height:100%;
                background: center;
                background-size:cover;                
            }
            img{
                width:100%;
            }
            .blank_img{
                background:black;
                height:100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 1rem;
                color: #edf2f7;
                font-weight: 700;
            }
        }
        .item_footer{
            padding-left: 1rem;
            padding-right: 1rem;
            padding-top: .5rem;
            padding-bottom: .5rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: #1a202c;
            height:35px;
            h1{
                font-size: 1rem;
                color: #edf2f7;
                font-weight: 700;
                margin:0;
            }
            button{
                font-size: .7rem;
                color: #1a202c;
                padding-left: .75rem;
                padding-right: .75rem;
                padding-top: .25rem;
                padding-bottom: .25rem;
                font-weight: 600;
                border-radius: .25rem;
                background-color: #edf2f7;
                cursor: pointer;
                line-height: inherit;
                border-width: 0;
            }
        }
        .point_item{
            background:#5a001a;
        }
    }
}
.empty_list{
    text-align: center;
    padding:50px;
    background:#ccc;
    border-radius: 5px;
    margin:20px 0;
}
</style>
